import { render, staticRenderFns } from "./pcIndex.vue?vue&type=template&id=04e73b70&scoped=true&"
import script from "./pcIndex.vue?vue&type=script&lang=ts&"
export * from "./pcIndex.vue?vue&type=script&lang=ts&"
import style0 from "./pcIndex.vue?vue&type=style&index=0&id=04e73b70&scoped=true&lang=scss&"
import style1 from "./pcIndex.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.9.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e73b70",
  null
  
)

export default component.exports